interface IPlusIconProps {
  className?: string
}

const PlusIcon = ({ className }: IPlusIconProps) => (
  <svg
    width="24"
    height="24"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="24 / basic / plus">
      <path
        id="icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 11H22V13H13V22H11V13H2V11H11V2H13V11Z"
        fill="#999999"
      />
    </g>
  </svg>
)

export default PlusIcon
